import { render, staticRenderFns } from "./Specialty.vue?vue&type=template&id=9e00a214&scoped=true"
import script from "./Specialty.vue?vue&type=script&lang=ts"
export * from "./Specialty.vue?vue&type=script&lang=ts"
import style0 from "./Specialty.vue?vue&type=style&index=0&id=9e00a214&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e00a214",
  null
  
)

export default component.exports